<template>
  <v-content
    class="pa-0"
  >
    <v-container
      class="ma-0 pa-0"
      fluid
      v-if="isReady"
    >
      <v-tabs
        v-model="tab"
        fixed-tabs
        background-color="#FF5500"
        dark
      >
        <v-tab
          class="text-capitalize"
        >
          Users
        </v-tab>
        <v-tab
          class="text-capitalize"
        >
          Shots
        </v-tab>
        <v-tab
          class="text-capitalize"
        >
          Rooms
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <!-- users -->
          <v-data-table
            :headers="users.header"
            :items="users.items"
            :items-per-page="30"
          >
            <template v-slot:item.photo="{ item }">
              <img :src="item.photo_url" width="50" height="50" />
            </template>
            <template v-slot:item.name="{ item }">
              {{ item.nickname }}<br />{{ item.birthday }}<br />{{ item.gender }}
            </template>
            <template v-slot:item.keys="{ item }">
              {{ item.email }}<br />{{ item.uid }}
            </template>
            <template v-slot:item.comment="{ item }">
              <textarea :title="item.comment" v-model="item.comment"></textarea>
            </template>
            <template v-slot:item.date="{ item }">
              <template v-if="item.modified">{{ item.modified }}</template>
              <template v-else>{{ item.created }}</template>
            </template>
          </v-data-table>
        </v-tab-item>
        
        <v-tab-item>
          <!-- posts -->
          <v-data-table
            :headers="posts.header"
            :items="posts.items"
            :items-per-page="30"
          >
            <template v-slot:item.author="{ item }">
              <img :src="item.photo_url_u" :title="item.nickname" width="50" height="50" />
            </template>
            <template v-slot:item.photo_url_p="{ item }">
              <img :src="item.photo_url_p" width="50" height="50" />
            </template>
            <template v-slot:item.comment="{ item }">
              <textarea :title="item.comment" v-model="item.comment"></textarea>
            </template>
            <template v-slot:item.date="{ item }">
              {{ item.pid }}<br />
              <template v-if="item.modified">{{ item.modified }}</template>
              <template v-else>{{ item.created }}</template>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item>
          <!-- rooms -->
          <v-data-table
            :items-per-page="5"
            :headers="rooms.header"
            :items="rooms.items"
            @click:row="showRoom"
          >
            <template v-slot:item.photo_url_1="{ item }">
              <img :src="item.photo_url_1" width="50" height="50" />
            </template>
            <template v-slot:item.photo_url_2="{ item }">
              <img :src="item.photo_url_2" width="50" height="50" />
            </template>
            <template v-slot:item.rid="{ item }">
              <v-btn @click="showRoom(item)">Show</v-btn>
            </template>
          </v-data-table>

          <!-- comments -->
          <v-data-table
            :headers="comments.header"
            :items="comments.items"
            :items-per-page="30"
          >
            <template v-slot:item.photo_url="{ item }">
              <img :src="item.photo_url" width="50" height="50" />
            </template>
            <template v-slot:item.key="{ item }">
              {{ item.uid }}<br />{{ item.rid }}
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>

    </v-container>

    <bottomNavigation
      activeNav="bookmark"
    ></bottomNavigation>

  </v-content>
</template>

<script>
import BottomNavigation from '@/components/Like/BottomNavigation'
import service from '@/plugins/service'
import pageTitle from '@/components/Like/PageTitle'
import blockTitle from '@/components/Like/BlockTitle'
import blockContent from '@/components/Like/BlockContent'

export default {
  components: {
    BottomNavigation,
    pageTitle,
    blockTitle,
    blockContent,
  },
  data: () => ({
    isReady: false,
    tab: null,
    user: {},
    subtitle: '',
    users: {
      header: [
        { text: 'photo', value: 'photo', },
        { text: 'nickname / birthday / gender', value: 'name', width: 300, },
        { text: 'about me', value: 'comment', },
        { text: 'email / uid', value: 'keys', },
        { text: 'date', value: 'date', },
      ],
      items: [],
    },
    posts: {
      header: [
        { text: 'author', value: 'author', },
        { text: 'top photo', value: 'photo_url_p', },
        { text: 'select like', value: 'like_name', },
        { text: 'about passion', value: 'comment', },
        { text: 'shots id / last modifed', value: 'date', },
      ],
      items: [],
    },
    rooms: {
      header: [
        { text: 'show detail', value: 'rid', },
        { text: 'lastest date', value: 'max_created', },
        { text: 'user 1', value: 'photo_url_1', },
        { text: 'user 2', value: 'photo_url_2', },
      ],
      items: [],
    },
    comments: {
      header: [
        { text: 'user photo', value: 'photo_url', },
        { text: 'comment', value: 'comment', },
        { text: 'is read', value: 'is_read', },
        { text: 'uid / rid', value: 'key', },
      ],
      items: [],
    },
  }),
  async mounted() {
    // ログインチェック
    try {
      this.user = await service.authCheck()
    } catch (e) {
      this.$router.push('/')
      return
    }
    // 管理者チェック
    const json = await service.getPassions({
      uid: this.user.uid,
      target: 'namea',
    })
    if (!json.key) {
      this.$router.push('/')
      return
    }
    this.isReady = true
    // users
    const users = await service.getPassions({
      uid: this.user.uid,
      target: 'users',
    })
    users.list.forEach(item => this.users.items.push(item))
    // posts
    const posts = await service.getPassions({
      uid: this.user.uid,
      target: 'posts',
    })
    posts.list.forEach(item => this.posts.items.push(item))
    // rooms
    const rooms = await service.getPassions({
      uid: this.user.uid,
      target: 'comments',
    })
    rooms.list.forEach(item => this.rooms.items.push(item))
  },
  methods: {
    async showRoom(item) {
      const comments = await service.getPassions({
        uid: this.user.uid,
        target: 'comments',
        rid: item.rid,
      })
      console.log(comments)
      this.comments.items.splice(0)
      comments.list.forEach(item => this.comments.items.push(item))
    }
  },
}
</script>
